import styled from 'styled-components';

import { SWReactCountryIcons } from '@similarweb/icons';
import { colorsPalettes, truncateText, setFontVariant } from '@similarweb/styles';

export const StyledChartCardWrapper = styled.div<{
  compact?: boolean;
}>`
  width: 100%;
  max-width: 100%;
  margin: ${({ compact }) => (compact ? '16px 0 12px 0' : '16px 0')};
`;

export const StyledChartCardContainer = styled.div`
  box-shadow: 0px 1.367px 2.733px 0px rgba(14, 30, 62, 0.08);
  border-radius: 6px;
`;

export const StyledChartCard = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  border: 0.5px solid #ececec;
  background: ${colorsPalettes.carbon[0]};
`;

export const StyledChartCardHeader = styled.div<{ withBorder?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 12px;
  border-bottom: ${({ withBorder }) => (withBorder ? `0.5px solid ${colorsPalettes.carbon[100]}` : 'none')};
  row-gap: 6px;
`;

export const StyledChartCardTitle = styled.h4`
  width: 100%;
  ${setFontVariant('primaryItem', colorsPalettes.carbon[500])};
  line-height: normal;
  margin: 0;
`;

export const StyledChartCardHeaderInfo = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;

  *:not(:last-child) {
    flex: none;
  }
`;

export const StyledChartCardSubtitle = styled.span`
  ${setFontVariant('listItem3', colorsPalettes.carbon[400])};
  margin-left: 8px;
  ${truncateText()};
`;

export const StyledChartCardCountryFlag = styled(SWReactCountryIcons)`
  margin-left: 16px;
`;

export const StyledChartCardBodyWrapper = styled.div`
  position: relative;
  overflow: hidden;
`;

export const StyledChartCardFooter = styled.div<{ extendedPadding: boolean }>`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: ${({ extendedPadding }) => (extendedPadding ? '0 16px 8px 16px' : '0 12px 8px')};

  & > svg {
    width: 60px;
  }
`;
